/**
 * Enumération des types d'activités pour lesquels une actualité peut être publiée
 */
export enum ActiviteActualiteEnum {
    HYPER = "101",
    SUPER = "102",
    EXPRESS = "114",
    PROXI = "128",
}

export class ActiviteActualiteUtils {
    static getValuesAsList(): string[] {
        return Object.values(ActiviteActualiteEnum);
    }

    static isHyperOrSuper(value: string): boolean {
        return [ActiviteActualiteEnum.HYPER.valueOf(), ActiviteActualiteEnum.SUPER.valueOf()].includes(value);
    }

    static isExpressOrProxi(value: string): boolean {
        return [ActiviteActualiteEnum.EXPRESS.valueOf(), ActiviteActualiteEnum.PROXI.valueOf()].includes(value);
    }

    static canBeOnlyMaster(codeActivite: string): boolean {
        return [
            ActiviteActualiteEnum.HYPER.valueOf(),
            ActiviteActualiteEnum.SUPER.valueOf(),
        ].includes(codeActivite);
    }

    static canBeMaster(codeActivite: string): boolean {
        return [
            ActiviteActualiteEnum.HYPER.valueOf(),
            ActiviteActualiteEnum.SUPER.valueOf(),
            ActiviteActualiteEnum.EXPRESS.valueOf(),
            ActiviteActualiteEnum.PROXI.valueOf(),
        ].includes(codeActivite);
    }

    static canBeOnlyConcept(codeActivite: string): boolean {
        return ![
            ActiviteActualiteEnum.HYPER.valueOf(),
            ActiviteActualiteEnum.SUPER.valueOf(),
            ActiviteActualiteEnum.EXPRESS.valueOf(),
            ActiviteActualiteEnum.PROXI.valueOf(),
        ].includes(codeActivite);
    }

    static canBeMasterAndConcept(codeActivite: string): boolean {
        return [
            ActiviteActualiteEnum.EXPRESS.valueOf(),
            ActiviteActualiteEnum.PROXI.valueOf(),
        ].includes(codeActivite);
    }
}

